// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2Eg_R","range":"MonthRangeSwitch_range__slYMJ","disabled":"MonthRangeSwitch_disabled__3TQ0c"};